import { render, staticRenderFns } from "./ArtistPortalAccess.vue?vue&type=template&id=ff2bf4ca&scoped=true"
import script from "./ArtistPortalAccess.vue?vue&type=script&lang=js"
export * from "./ArtistPortalAccess.vue?vue&type=script&lang=js"
import style0 from "./ArtistPortalAccess.vue?vue&type=style&index=0&id=ff2bf4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2bf4ca",
  null
  
)

export default component.exports